import styled from 'styled-components'

export const TrackRowDragImage = styled.div.attrs({
	'aria-hidden': true,
})`
	${(props) => props.theme.typography.bodyM}
	left: -100vw;
	top: -100vh;
	position: absolute;
	padding: 0.5rem 0.6rem 0.5rem 0.6rem;
	border-radius: 0.125rem;
	background-color: ${(props) => props.theme.colors.backgroundSecondary};
`

export const TrackRowDragImageTitle = styled.span`
	font-weight: 600;
`
